import { makeStyles } from '@material-ui/core';
export default makeStyles((theme) => ({
  entireDistribution: {
    // padding: '50px 165px 35px 188px',
    // '@media (max-width: 1125px)': {
    //   padding: '50px 5% 35px',
    // },
    // '@media (max-width: 767px)': {
    //   padding: '0px 5% 15px',
    // },
  },
  distributionText: {
    fontSize: 15,
    color: theme.palette.grey[50],
    letterSpacing: 0.3,
    marginBottom: 14,
    lineHeight: 1.5,
  },
  inputWrap: {
    marginBottom: -15,
  },
  amount: {
    fontWeight: 'bold',
    color: theme.palette.secondary.main,
    fontSize: 17,
  },
  selectInput: {
    marginBottom: 0,
    display: 'inline',
  },
  uploadBtn: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    borderRadius: 10,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    width: 320,
    fontSize: 16,
    cursor: 'pointer',
    height: 48,
    marginBottom: 30,
    letterSpacing: 0.3,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
    '@media (max-width: 1125px)': {
      width: 280,
    },
  },
  nextPrevButtonBox: {
    paddingTop: 30,
    display: 'flex',
    paddingBottom: 10,
  },
  prevButton: {
    backgroundColor: theme.palette.warning.main,
    color: theme.palette.secondary.main,
    borderRadius: 10,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    width: 152,
    fontSize: 16,
    cursor: 'pointer',
    height: 57,
    letterSpacing: 0.3,
    marginRight: 18,
    textTransform: 'capitalize',
    border: '1px solid',
    borderColor: theme.palette.secondary.main,
    '&:hover': {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.secondary.main,
      borderColor: theme.palette.secondary.main,
    },
  },
  nextButton: {
    backgroundColor: theme.palette.secondary.main,
    color: theme.palette.secondary.contrastText,
    borderRadius: 10,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 800,
    fontSize: 16,
    cursor: 'pointer',
    height: 57,
    letterSpacing: 0.3,
    textTransform: 'capitalize',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
  },
  errorMessage: {
    fontSize: 15,
    letterSpacing: 0.35,
    color: theme.palette.error.main,
  },
  amountSelect: {
    width: 180,
    marginBottom: 20,
  },
  textValInput: {
    marginBottom: 35,
    width: '100%',
  },
  percentage: {
    marginLeft: 5,
  },
  amountTextField: {
    display: 'inline',
    alignItems: 'baseline',
    marginLeft: 8,
  },
  inputRoot: {
    fontSize: 16,
    width: '100%',
    '&:hover': {
      '&:not(.Mui-disabled)::before': {
        borderBottomColor: theme.palette.primary.light,
      },
    },
  },
  labelRoot: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 15,
    letterSpacing: 0.35,
  },
  labelFocused: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 15,
    transform: 'translate(0, 1.5px) scale(1)',
  },
  selectValInput: {
    marginTop: 0,
    marginBottom: 30,
    width: '20%',
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
    },
    '& .MuiSelect-select.MuiSelect-select': {
      paddingTop: 9,
    },
  },
}));
